export default {
  reserveBtnText: "ดาวน์โหลด\nเกม",
  pageTitle: "RO World Journey หน้าร่วมสร้างสรรค์ผู้เล่น",
  loginBtn: "เข้าสู่ระบบ",
  logoutBtn: "[ ออกจากระบบ ]",
  joinActivityText: 'มีผู้เล่น <span class="number">${n}</span> คนเข้าร่วมแล้ว',
  search: "ค้นหา",
  searchPlaceholder: "ใส่ชื่อผู้สร้าง / คำค้นหา",
  filter: "กรอง",
  sortBy: "เรียงตาม",
  sortByTime: "ล่าสุด",
  sortByHot: "ยอดนิยม",
  releaseTime: "เวลาเผยแพร่",
  noLimit: "ทั้งหมด",
  oneDay: "ภายใน 1 วัน",
  oneWeek: "ภายใน 1 สัปดาห์",
  reset: "รีเซ็ต",
  loginTip: "เข้าสู่ระบบเพื่อร่วมสร้างสรรค์",
  nowLoginBtn: "เข้าสู่ระบบตอนนี้",
  home: "กลับหน้าหลัก",
  creativeCenter: "ผลงานของฉัน",
  developmentLog: "บันทึกนักพัฒนา",
  devSectionSubtitle: "แด่ทุกหัวใจที่รอคอยการกลับมาของ RO",
  feedback: "ความคิดเห็น",
  feedbackPopupTitle: "ส่งความคิดเห็น",
  feedbackAccount: "บัญชีปัจจุบัน:",
  notLoggedIn: "ยังไม่ได้เข้าสู่ระบบ",
  feedbackEmail: "อีเมล:",
  feedbackEmailPlaceholder: "กรอกอีเมลติดต่อ",
  feedbackCategory: "หมวดหมู่:",
  feedbackCategoryPlaceholder: "เลือกหมวดหมู่ความคิดเห็น",
  feedbackCat1: "บักในเกม",
  feedbackCat2: "คำขอฟีเจอร์",
  feedbackCat3: "ปรับปรุงระบบ",
  feedbackCat4: "อื่นๆ",
  feedbackContent: "เนื้อหาความคิดเห็น:",
  feedbackContentPlaceholder: "กรุณาอธิบายความคิดเห็นของคุณโดยละเอียด",
  feedbackAttachment: "ไฟล์แนบ",
  feedbackAttachmentLimit: "แนบได้สูงสุด 3 ไฟล์",
  feedbackAddAttachment: "เพิ่มไฟล์แนบ",
  feedbackErrEmail: "กรุณากรอกอีเมล",
  feedbackErrCategory: "กรุณาเลือกหมวดหมู่",
  feedbackErrContent: "กรุณากรอกเนื้อหาความคิดเห็น",
  feedbackErrFileSize: "ขนาดไฟล์ต้องไม่เกิน 10MB",
  feedbackErrFileType: "รองรับเฉพาะรูปภาพ (JPG/PNG) และเอกสาร (PDF/DOC/DOCX)",
  exitConfirmTitle: "แจ้งเตือน",
  exitConfirmLine1: "ข้อมูลที่กรอกไว้จะไม่ถูกบันทึกเมื่อออก",
  exitConfirmLine2: "ต้องการออกใช่หรือไม่",
  publishTime: "เผยแพร่: ",
  selectType: "เลือกประเภท",
  createType1: "ออกแบบชุด",
  createType2: "ออกแบบหมวก",
  createType3: "กิจกรรม Meme",
  createType4: "ความทรงจำ RO ของฉัน",
  createType5: "แชร์ภาพสุดปัง",
  createType6: "Poring ของฉัน",
  createType7: "แชร์ Class",
  ugcJoinBtn: 'เข้าร่วม',
  kolPopupTitle: "สมัคร KOL",
  kolAccount: "บัญชีปัจจุบัน :",
  kolEmail: "อีเมล :",
  kolEmailPlaceholder: "กรุณากรอกอีเมลสำหรับติดต่อ",
  kolDiscordId: "Discord User ID :",
  kolDiscordIdPlaceholder: "กรุณากรอก Discord User ID",
  kolSpecialty: "ความถนัดในการสร้างสรรค์ :",
  kolSpecialtyPlaceholder: "กรุณาเลือกความถนัดในการสร้างสรรค์",
  kolSpecialty1: "เขียนแนวทางการเล่น",
  kolSpecialty2: "การออกแบบอาร์ตเวิร์ก",
  kolSpecialty3: "การสร้างวิดีโอ",
  kolSpecialty4: "อื่นๆ",
  kolWorkUrl: "ลิงก์ผลงานที่ผ่านมา :",
  kolWorkUrlPlaceholder: "กรุณาใส่ลิงก์ผลงานที่ผ่านมา หากมีหลายลิงก์ให้คั่นด้วยจุลภาค",
  kolFollower: "จำนวนผู้ติดตาม :",
  kolFollowerPlaceholder: "กรุณาใส่จำนวนผู้ติดตามปัจจุบัน",
  kolSubmitBtn: "ส่ง",
  kolErrEmail: "กรุณากรอกอีเมล",
  kolErrEmailFormat: "กรุณากรอกรูปแบบอีเมลที่ถูกต้อง",
  kolErrDiscord: "กรุณากรอก Discord User ID",
  kolErrSpecialty: "กรุณาเลือกความถนัดในการสร้างสรรค์",
  kolErrWorkUrl: "กรุณาใส่ลิงก์ผลงานที่ผ่านมา",
  kolErrFollower: "กรุณาใส่จำนวนผู้ติดตามที่ถูกต้อง",
  kolSubmitSuccess: "ส่งคำสมัครสำเร็จ",
  feedbackSuccessTitle: 'เรียน Novice ที่รัก',
  feedbackSuccessContent: 'ยินดีด้วย! ส่งข้อมูลสำเร็จแล้ว!',
  kolSubmitFail: "การส่งล้มเหลว กรุณาลองใหม่ภายหลัง",
  kolNetworkFail: "การส่งล้มเหลว กรุณาตรวจสอบการเชื่อมต่อเครือข่าย",
  kolSubtitle: "เข้าร่วมทีมครีเอเตอร์",
  kolContent: "ที่นี่ นอกจากจะได้แลกเปลี่ยนเรียนรู้กับเหล่าครีเอเตอร์ที่ยอดเยี่ยมแล้ว ยังมีโอกาสได้รับของรางวัลสุดพิเศษอีกมากมาย! รีบคลิกสมัครเลย",
  kolViewBtn: "ดูเพิ่มเติม",
  lotterySubTitle: 'เข้าร่วมกิจกรรมสร้างสรรค์เพื่อรับคะแนน,<br><span class="red">ลุ้นรับไอเทมลิมิเต็ดและของรางวัลสุดพรีเมียม!</span>',
  drawSubTitle: 'พรีวิวรางวัลใหญ่บางส่วน',
  physicalRewardsLabel: 'รางวัลจริง:',
  inGameRewardsLabel: 'รางวัลในเกม:',
  myPoints: "คะแนนสะสม : ",
  viewPointDetail: "ดูรายละเอียดคะแนน >>",
  currentTitle: "ฉายาปัจจุบัน : ",
  taskRuleBtn: "กฎกิจกรรม",
  taskBtnFinished: "เสร็จสิ้น",
  taskBtnEnded: "สิ้นสุดแล้ว",
  taskBtnGo: "ไปเลย",
  taskDailyLoginTitle: "ล็อกอินครั้งแรกของวัน",
  taskDailyLoginDesc: "ล็อกอินรายวัน (5 คะแนน)",
  taskReserveTitle: "ดาวน์โหลดเกม",
  taskReserveDesc: "ดาวน์โหลดเกมเป็นครั้งแรก (25 คะแนน)",
  taskFeedbackTitle: "ส่งข้อเสนอแนะ",
  taskFeedbackDesc: "ส่งข้อเสนอแนะครั้งแรกของวัน (15 คะแนน)",
  taskRoMemoryTitle: "ส่งผลงาน My Poring",
  taskRoMemoryDesc: "ส่งผลงานครั้งแรกของวัน (25 คะแนน) จำกัดสูงสุด 50 คะแนนต่อสัปดาห์",
  taskCostumeTitle: "ส่งผลงานแชร์อาชีพ",
  taskCostumeDesc: "ส่งผลงานครั้งแรกของวัน (25 คะแนน) ขีดจำกัดรายสัปดาห์ 25 คะแนน",
  taskPhotoTitle: "ส่งผลงานแชร์ภาพสวย",
  taskPhotoDesc: "ส่งผลงานครั้งแรกของวัน (25 คะแนน) ขีดจำกัดรายสัปดาห์ 50 คะแนน",
  taskLikeOtherTitle: "กดไลค์ผลงานของผู้อื่น",
  taskLikeOtherDesc: "กดไลก์รับ 0.5 คะแนน จำกัดวันละ 5 คะแนน ({n}/5 คะแนน)",
  taskLikeMyTitle: "ผลงานได้รับไลก์",
  taskLikeMyDesc: "ได้รับ 1 ไลก์ รับ 1 คะแนน จำกัดสัปดาห์ละ 200 คะแนน ({n}/200 คะแนน)",
  taskFbTitle: "ติดตาม Facebook",
  taskFbDesc: "ติดตาม Facebook Official (10 คะแนน)",
  taskDcTitle: "ติดตาม Discord",
  taskDcDesc: "ติดตาม Discord Official (10 คะแนน)",
  taskYtbTitle: "ติดตาม YouTube",
  taskYtbDesc: "ติดตาม YouTube Official (10 คะแนน)",
  taskLineTitle: "ติดตาม LINE",
  taskLineDesc: "ติดตาม LINE Official (10 คะแนน)",
  ugcTabContent6: "ขาวดำ สีชมพู หรือสร้างจากโค้ด...|Poring ในใจคุณเป็นแบบไหน?|มาแชร์ผลงาน Poring ของคุณ|ให้ความน่ารักยึดครอง Midgard กัน!|กติกาการเข้าร่วม:|แชร์ Poring ที่คุณวาดหรือสร้างขึ้นเอง|ไม่จำกัดรูปแบบ จะเป็นภาพวาดด้วยมือ|โค้ด หรือรูปแบบอื่นๆ ก็ได้",
  ugcTabContent7: "แชร์แนวทางการอัปสกิลและไฮไลท์การต่อสู้ของคุณ|ให้นักผจญภัยคนอื่นได้เห็นช่วงเวลาสุดปังของ Class คุณ!|กติกาการเข้าร่วม:|อัปโหลดสกรีนช็อตการต่อสู้หรือการอัปสกิล|ของ Class ใดก็ได้ในเกม",
  ugcTabContent5: "โลกกว้างไร้รอยต่อคือสตูดิโอถ่ายภาพชั้นยอด!|มาอวดสไตล์การแต่งตัวที่เป็นเอกลักษณ์|เช็กอินวิวสวยๆ และบันทึกช่วงเวลาสุดประทับใจ|ของคุณใน Midgard!|กติกาการเข้าร่วม:|อัปโหลดสกรีนช็อตการย้อมสี|หรือการมิกซ์แอนด์แมตช์ชุดในเกม พร้อมภาพวิวทิวทัศน์",
  communicationType1: "ความคิดเห็น",
  communicationType2: "บันทึกนักพัฒนา",
  inputTitle: "ใส่หัวข้อ",
  inputContent: "ใส่เนื้อหา",
  uploadImage: "แก้ไขรูปภาพ",
  uploadImageTip: "ลากเพื่อจัดเรียง",
  addImage: "เพิ่ม",
  creationBtnText: "โพสต์",
  publish: "เผยแพร่",
  loading: "กำลังโหลด",
  publishSuccess: "เผยแพร่แล้ว รอการตรวจสอบ",
  commonTip: "กรุณาลองใหม่อีกครั้ง",
  editSaveTip: "บันทึกการแก้ไขนี้?",
  saveCancel: "ยกเลิก",
  saveConfirm: "บันทึก",
  myCreative: "ผลงานสร้างสรรค์ของฉัน",
  deleteTip: "ลบผลงานนี้?",
  confirmBtn: "ยืนยัน",
  cancelBtn: "ยกเลิก",
  submitBtn: "ส่ง",
  tipPopupTitle: "แจ้งเตือน",
  loginPopupTitle: "แจ้งเตือน",
  scoreDetailTitle: "แต้มของฉัน",
  lotterySuccTitle: "ยินดีด้วย",
  physicalAwardTitle: "กรอกที่อยู่จัดส่ง",
  physicalCheckTitle: "แจ้งเตือน",
  vtCodeTitle: "รับแล้ว",
  realNameLabel: "ชื่อจริง",
  phoneLabel: "มือถือ",
  areaCodeLabel: "รหัสพื้นที่",
  addressLabel: "ที่อยู่จัดส่ง",
  countryLabel: "ประเทศ/ภูมิภาค",
  postalCodeLabel: "รหัสไปรษณีย์",
  confirmShippingTip: "ข้อมูลจัดส่งไม่สามารถเปลี่ยนแปลงได้หลังจากยืนยัน<br />คุณแน่ใจหรือไม่?",
  submitSuccessTip: "ส่งสำเร็จ",
  scoreItemLabel: "รายการ",
  scoreChangeLabel: "แต้ม",
  scoreTimeLabel: "เวลา",
  lotteryDrawLabel: "จับฉลากแต้ม",
  auditResultNotice: "ผลการตรวจสอบ",
  auditResultContent:
    "ผู้เล่นที่รัก<br/><br/>ผลงานของคุณชื่อ 【${title}】 ที่ส่งเมื่อ ${time} ไม่ผ่านการตรวจสอบ กรุณาแก้ไขและส่งใหม่",
  auditReason: "เหตุผล: ",
  auditTime: "เวลาตรวจสอบ: ",
  emptyNotice: "ไม่มีเนื้อหา",
  emptyWorks: "เป็นคนแรกที่สร้าง!",
  viewImage: "คลิกเพื่อดูต้นฉบับ",
  createPopupTitle: "เผยแพร่ผลงาน",
  gameName: "RO World Journey",
  gameType: "Open-World RO",
  loadingMore: "เลื่อนเพื่อโหลดเพิ่มเติม",
  noMoreData: "ไม่มีเนื้อหาอีกแล้ว",
  auditPass: "เผยแพร่แล้ว",
  auditFail: "ถูกปฏิเสธ",
  auditState: "อยู่ระหว่างตรวจสอบ",
  ugcRuleRules: `<Ragnarok: The New World>กฎกิจกรรมส่งผลงาน UGC

1) ข้อกำหนดเกี่ยวกับเนื้อหาผลงาน
1. เนื้อหาผลงานทั้งหมดต้องเกี่ยวข้องกับ <Ragnarok: The New World> และต้องเป็นผลงานที่ผู้ส่งสร้างสรรค์ขึ้นเอง ห้ามลอกเลียนแบบ ขโมยผลงาน นำผลงานผู้อื่นมาใช้ หรือใช้วัสดุของผู้อื่นโดยไม่ได้รับอนุญาต
2. เนื้อหาผลงานต้องสอดคล้องกับหัวข้อการแข่งขันและข้อกำหนดของกิจกรรม
3. หากเนื้อหาผลงานมีวัสดุ เพลง รูปภาพ หรือเนื้อหาอื่นๆ ที่มีลิขสิทธิ์ของบุคคลที่สาม ผู้ส่งผลงานต้องแน่ใจว่าได้รับอนุญาตอย่างถูกต้องตามกฎหมาย ข้อพิพาทและความรับผิดใดๆ ที่เกิดจากปัญหาลิขสิทธิ์ ผู้ส่งผลงานจะต้องรับผิดชอบด้วยตนเอง
4. ทีมงานมีสิทธิ์ในการตรวจสอบเนื้อหาผลงานทั้งหมด สำหรับเนื้อหาที่ละเมิดกฎ ไม่เหมาะสม มีคุณภาพต่ำ ไม่เกี่ยวข้องกับกิจกรรม หรือไม่ตรงตามข้อกำหนดของกิจกรรม ทีมงานมีสิทธิ์ปฏิเสธการแสดงผลงาน ยกเลิกสิทธิ์ในการเข้าร่วมกิจกรรม และไม่มอบคะแนนหรือรางวัลใดๆ ที่เกี่ยวข้อง

2) การแสดงผลงานและการโต้ตอบ
1. ผลงานที่ผ่านการตรวจสอบจะถูกแสดงบนหน้ากิจกรรมในส่วน "แกลเลอรีผลงาน"
2. ผู้เล่นสามารถรับชม กดถูกใจ และโต้ตอบกับผลงานที่จัดแสดงได้
3. ทีมงานมีสิทธิ์ในการปรับเปลี่ยนลำดับการแสดงผลงาน เนื้อหาแนะนำ และรูปแบบการจัดแสดงตามความจำเป็นในการดำเนินกิจกรรม

3) การอนุญาตให้ใช้สิทธิ์ในผลงานและคำแนะนำในการใช้งาน
1. เมื่อส่งผลงานสำเร็จ จะถือว่าผู้ส่งผลงานได้ยินยอมมอบสิทธิ์การใช้งานให้แก่ทีมงาน <Ragnarok: The New World> ทั่วโลกอย่างถาวร เพิกถอนไม่ได้ ไม่ผูกขาด และไม่มีค่าลิขสิทธิ์
2. ทีมงานสามารถนำเนื้อหาผลงานไปใช้ได้ทั้งในและนอกเกม เว็บไซต์ทางการ แพลตฟอร์มโซเชียลมีเดีย การประชาสัมพันธ์ทางการตลาด การโปรโมตกิจกรรม การผลิตสินค้า และเนื้อหาดัดแปลงอื่นๆ ที่เกี่ยวข้อง
3. เพื่อให้สอดคล้องกับความต้องการด้านการประชาสัมพันธ์และการดำเนินงาน ทีมงานมีสิทธิ์ในการแก้ไข ปรับปรุง ดัดแปลง หรือสร้างสรรค์เนื้อหาผลงานขึ้นใหม่ตามความจำเป็น
4. ผู้ส่งผลงานยังคงเป็นเจ้าของลิขสิทธิ์และสิทธิ์ในการแสดงชื่อของผลงานต้นฉบับ

4) การเข้าร่วมกิจกรรมและรายละเอียดของรางวัล
1. ผู้เล่นจะต้องดำเนินการต่างๆ ที่เกี่ยวข้องกับกิจกรรมให้เสร็จสิ้นภายในเวลาที่กำหนด ซึ่งรวมถึงแต่ไม่จำกัดเพียง การส่งผลงาน การรับและแลกคะแนน การรับรางวัล และการกรอกข้อมูลที่อยู่สำหรับจัดส่ง
2. หากผู้เล่นไม่ได้ดำเนินการให้เสร็จสิ้นภายในระยะเวลาที่กำหนด จะถือว่าสละสิทธิ์ในคุณสมบัติ คะแนน หรือรางวัลนั้นๆ โดยอัตโนมัติ
3. สำหรับรางวัลที่ไม่ได้กดรับ คะแนนที่ไม่ได้ใช้ หรือข้อมูลที่ไม่ได้กรอกภายในเวลาที่กำหนด ทีมงานจะไม่ทำการมอบให้ย้อนหลังหรือกู้คืนให้ใหม่
4. กรณีที่ผู้เล่นกรอกข้อมูลส่วนตัวผิดพลาด ไม่ครบถ้วน หมดอายุ หรือไม่ได้อัปเดตข้อมูลให้เป็นปัจจุบัน จนเป็นเหตุให้ไม่สามารถเข้าร่วมกิจกรรมหรือรับรางวัลได้ ทีมงานจะไม่รับผิดชอบใดๆ ทั้งสิ้น
5. หากเกิดจากบัญชีผิดปกติ ถูกแฮก ปัญหาอุปกรณ์ ปัญหาเครือข่าย หรือการละเมิดกฎของเกม จนทำให้บัญชีถูกจำกัดหรือระงับการใช้งาน และส่งผลกระทบต่อการเข้าร่วมกิจกรรมหรือการรับรางวัล ทีมงานจะไม่รับผิดชอบใดๆ ทั้งสิ้น หากบัญชีถูกระงับการใช้งานระหว่างกิจกรรม คะแนนที่ยังไม่ได้ใช้และรางวัลที่ยังไม่ได้กดรับจะถือเป็นโมฆะโดยอัตโนมัติ

5) การป้องกันการทุจริตและการจัดการกับการละเมิดกฎ
ทีมงานจะตรวจสอบพฤติกรรมการเข้าร่วมกิจกรรมอย่างเข้มงวด หากตรวจพบพฤติกรรมการละเมิดกฎดังต่อไปนี้ ทีมงานจะดำเนินการทันที ซึ่งรวมถึงแต่ไม่จำกัดเพียง การระงับบัญชีที่เกี่ยวข้อง ยกเลิกสิทธิ์ในการเข้าร่วมกิจกรรมทั้งหมด เรียกคืนรางวัลที่ได้มอบไปแล้ว (รวมถึงไอเทมเสมือนที่ใช้ไปแล้ว) และขอสงวนสิทธิ์ในการดำเนินการทางกฎหมาย:
1. ใช้ช่องทางใดๆ ในการสมัครบัญชีจำนวนมาก (เช่น บุคคลเดียวกัน อุปกรณ์เดียวกัน หรือ IP เดียวกันมีหลายบัญชี) เพื่อเข้าร่วมกิจกรรม
2. ใช้ช่องโหว่ของโปรแกรม เครื่องมือที่ไม่ใช่ของทางการ หรือวิธีการที่ไม่ปกติใดๆ เพื่อปั๊มคะแนน
3. ใช้ซอฟต์แวร์เถื่อน โปรแกรมโกง หรือเครื่องมือช่วยเล่นจากบุคคลที่สามเพื่อรบกวนการดำเนินกิจกรรม
4. การกดถูกใจให้ตัวเอง การแลกกันกดถูกใจ การซื้อยอดถูกใจ หรือพฤติกรรมการโต้ตอบที่ผิดปกติหรือเป็นเท็จในทุกรูปแบบ
5. ให้ข้อมูลส่วนตัวที่เป็นเท็จหรือขโมยข้อมูลของผู้อื่น
6. พฤติกรรมอื่นใดที่ทีมงานพิจารณาว่าเป็นการละเมิดความยุติธรรมของกิจกรรมและส่งผลเสียต่อสภาพแวดล้อมของเกม

6) เหตุสุดวิสัย
ในกรณีที่เกิดเหตุสุดวิสัยซึ่งอยู่นอกเหนือการควบคุมของทีมงาน (รวมถึงแต่ไม่จำกัดเพียง: การเปลี่ยนแปลงนโยบายหรือกฎหมายของรัฐบาล ภัยพิบัติทางธรรมชาติ โรคระบาด สงคราม เป็นต้น) ทีมงานขอสงวนสิทธิ์ในการปรับเปลี่ยนระยะเวลาของกิจกรรม โดยอาจขยาย ลด หรือระงับกิจกรรมตามสถานการณ์ และจะประกาศให้ทราบล่วงหน้าอย่างน้อย 24 ชั่วโมงผ่านทางเว็บไซต์ทางการของเกมหรือแฟนเพจ ในกรณีที่เกิดเหตุสุดวิสัยกะทันหัน (รวมถึงแต่ไม่จำกัดเพียง: เซิร์ฟเวอร์ล่มอย่างรุนแรง การโจมตีจากแฮกเกอร์ เป็นต้น) ซึ่งไม่สามารถประกาศล่วงหน้าได้ ทีมงานจะดำเนินการประกาศให้ทราบโดยเร็วที่สุด

7) ข้อจำกัดความรับผิดชอบ
1. การเข้าร่วมกิจกรรมนี้ถือว่าผู้เล่นได้อ่าน ทำความเข้าใจ และยอมรับกฎและเงื่อนไขทั้งหมดของกิจกรรมนี้แล้ว
2. ผู้เยาว์หรือบุคคลที่ถูกจำกัดความสามารถในการทำนิติกรรม ควรเข้าร่วมกิจกรรมนี้หลังจากได้รับความยินยอมจากผู้ปกครองตามกฎหมายแล้วเท่านั้น
3. บันทึกทั้งหมดที่เกี่ยวข้องกับกิจกรรม รวมถึงการได้รับคะแนน การใช้คะแนน ผลการสุ่มรางวัล และการมอบรางวัล จะยึดตามบันทึกในระบบของทีมงานเป็นที่สิ้นสุด

※ ทีมงาน <Ragnarok: The New World> ขอสงวนสิทธิ์ในการตัดสินและตีความกิจกรรมนี้เป็นที่สิ้นสุด และมีสิทธิ์ในการปรับเปลี่ยนหรือเพิ่มเติมเนื้อหา กฎกติกา และของรางวัลของกิจกรรมได้ตามความเหมาะสมภายใต้ขอบเขตของกฎหมาย โดยเนื้อหาที่เกี่ยวข้องจะยึดตามประกาศจากทีมงานเป็นหลัก`,
  rulePopupTitle: "กฎกิจกรรม",
  overTenTips: "คุณเผยแพร่ครบ 10 ครั้งแล้ววันนี้ กลับมาพรุ่งนี้!",
  rulePopupContent: ``,
  backText: "กลับไป UGC",
  21000: "ยังไม่ได้เข้าสู่ระบบ",
  21001: "ไม่สามารถรับ URL อัพโหลดได้",
  21002: "การรวมไฟล์ล้มเหลว",
  21003: "จำนวน slice ไม่ถูกต้อง",
  21004: "Upload ID หรือ path ต้องไม่ว่างเปล่า",
  21005: "พารามิเตอร์ผิดพลาด",
  21006: "ส่งเนื้อหาล้มเหลว",
  21007: "กดไลค์ล้มเหลว",
  21008: "ล้างการแจ้งเตือนล้มเหลว",
  21010: "โพสต์มากเกินไปวันนี้ ลองพรุ่งนี้",
  21011: "ส่งมากเกินไปวันนี้ ลองพรุ่งนี้",
  21013: "ส่งมากเกินไปวันนี้ ลองพรุ่งนี้",
  21014: "รูปแบบอีเมลไม่ถูกต้อง",
  21018: "แต้มไม่เพียงพอ",
  21019: "จับรางวัลล้มเหลว",
  21022: "กิจกรรมยังไม่สิ้นสุด",
  21023: "ไม่มีรางวัลจริงที่สามารถรับได้",
  21024: "รับรางวัลจริงล้มเหลว",
  21025: "เนื้อหายาวเกินไป",
  21026: "คุณยังมีแต้มสำหรับจับรางวัล",
  21027: "ไม่มีรางวัลเสมือนที่สามารถรับได้",
  21028: "ไม่พบบันทึกรางวัล",
  21029: "รางวัลไม่เป็นของผู้ใช้นี้",
  21030: "ไม่ใช่รางวัลเสมือน",
  21031: "ยังไม่ได้รับรางวัล",
  viewMyRewardsBtn: "ดูรางวัลของฉัน",
  claimRewardsBtn: "รับรางวัล",
  claimVirtualBtn: "รับรางวัลเสมือน",
  claimPhysicalBtn: "รับรางวัลจริง",
  myRewardsTitle: "รางวัลของฉัน",
  prizeNameLabel: "ชื่อรางวัล",
  prizeQtyLabel: "จำนวนรางวัล",
  obtainTimeLabel: "เวลารับ",
  currentStatusLabel: "สถานะปัจจุบัน",
  viewGiftCodeBtn: "ดูโค้ดของขวัญ",
  claimTips: "*โปรดมารับรางวัลที่หน้านี้ในช่วงเปิดทดสอบ",
  congratulations: "ยินดีด้วยที่ได้รับ",
  giftCodeLabel: "รหัสของขวัญ :",
  copyBtn: "คัดลอก",
  copiedBtn: "คัดลอกแล้ว",
  useGiftCodeTips: "โปรดนำโค้ดที่ได้รับไปใช้ในเกม",
  unclaimedStatus: "รอรับ",
  claimedStatus: "รับแล้ว",
  oneDraw: "สุ่ม 1 ครั้ง",
  tenDraw: "สุ่ม 10 ครั้ง",
  lotteryPointCost: "แต้มที่ใช้ต่อครั้ง: 25 แต้ม",
  spendPointsFirst: "ใช้แต้มสุ่มรางวัลก่อน แล้วค่อยมารับรางวัลนะ~",
  claimVirtualRewardSuccess: "กรุณาตรวจสอบ [รางวัลของฉัน] สำหรับรหัสของขวัญ",
  submitting: "กำลังส่ง...",
  submitSuccess: "ส่งสำเร็จ!",
  submitFailed: "ส่งล้มเหลว กรุณาลองใหม่",
  imageRequired: "กรุณาอัพโหลดรูปภาพ",
  footerProvision: `
    <ol>
        <li>เกมนี้มีเนื้อหาที่เกี่ยวข้องกับความรุนแรง ความรัก และเครื่องแต่งกายที่เน้นรูปร่าง</li>
        <li>เนื้อหาบางส่วนต้องชำระเงินเพิ่มเติม</li>
        <li>กรุณาหลีกเลี่ยงการเล่นมากเกินไป</li>
    </ol>
  `,
  taskRulePopupTitle: "คำอธิบายกติกา",
  taskRuleRules: `กติกากิจกรรมจับฉลากคะแนน 《Ragnarok: The New World》

I. ระยะเวลากิจกรรม
17 กรกฎาคม 2026 เวลา 00:00 – 24 สิงหาคม 2026 เวลา 23:59 (UTC+7)

II. วิธีสะสมคะแนน
1. เข้าสู่ระบบครั้งแรกของวัน: 5 คะแนน/วัน จำกัด 1 ครั้ง/วัน
2. ลงทะเบียนล่วงหน้า: 25 คะแนน นับเฉพาะการลงทะเบียนครั้งแรกเท่านั้น
3. ติดตามบัญชีโซเชียลมีเดียทางการ (Facebook, Discord, LINE, YouTube): 10 คะแนน/แพลตฟอร์ม จำกัด 1 ครั้ง/แพลตฟอร์ม
4. ส่งความคิดเห็น: 15 คะแนน นับเฉพาะการส่งครั้งแรกของแต่ละวัน
5. ส่งผลงานกิจกรรม "Poring ของฉัน": ต้องส่งรูปภาพ 25 คะแนน นับเฉพาะการส่งครั้งแรกของแต่ละวัน จำกัดสูงสุด 2 ครั้ง/สัปดาห์
6. ส่งผลงานกิจกรรม "แชร์ Class": ต้องส่งรูปภาพ 25 คะแนน นับเฉพาะการส่งครั้งแรกของแต่ละวัน จำกัดสูงสุด 1 ครั้ง/สัปดาห์
7. ส่งผลงานกิจกรรม "แชร์ภาพสุดปัง": ต้องส่งรูปภาพ 25 คะแนน นับเฉพาะการส่งครั้งแรกของแต่ละวัน จำกัดสูงสุด 2 ครั้ง/สัปดาห์
8. กดไลก์ผลงานผู้อื่น: 0.5 คะแนน/ไลก์ นับเฉพาะไลก์แรกต่อผลงาน การยกเลิกแล้วกดใหม่จะไม่ได้รับคะแนนเพิ่ม จำกัดสูงสุด 10 ไลก์ที่ถูกต้องต่อวันเท่านั้นที่จะได้รับคะแนน
9. ผลงานได้รับไลก์จากผู้อื่น: 1 คะแนน/ไลก์ เพื่อป้องกันการโกง บัญชีเดียวจะได้รับคะแนนจากวิธีนี้สูงสุด 200 คะแนน/สัปดาห์
10. บัญชีที่กดไลก์ต้องเป็นบัญชีที่ใช้งานจริงและมีความเคลื่อนไหว ระบบทางการจะตรวจจับรูปแบบการกดไลก์ที่ผิดปกติ ทางการขอสงวนสิทธิ์ยกเลิกคะแนนที่ได้จากการโกง (รวมถึงแต่ไม่จำกัดเพียง การกดไลก์ตัวเอง กลุ่มกดไลก์ข้ามกัน ฯลฯ)
11. จำนวนครั้งที่เข้าร่วมรายวันจะรีเซ็ตเวลา 00:00 น. ของทุกวัน จำนวนครั้งที่เข้าร่วมรายสัปดาห์จะรีเซ็ตเวลา 00:00 น. ทุกวันจันทร์

III. กติกาจับฉลากคะแนน
1. ผู้เล่นสะสมคะแนนจากการเข้าร่วมกิจกรรมร่วมสร้างสรรค์ในช่วงกิจกรรม ทุก 25 คะแนนสามารถแลกสิทธิ์จับฉลาก 1 ครั้ง ทุก 250 คะแนนสามารถจับฉลาก 10 ครั้งรวด คะแนนใช้ได้เฉพาะในช่วงกิจกรรมเท่านั้น และจะหมดอายุเมื่อกิจกรรมสิ้นสุด
2. รางวัลและอัตราความน่าจะเป็น:
- ไม่ได้รางวัล (20%)
- ไอเทมในเกม: หมวกสุดพิเศษ [หูแมวดำ] ×1 (2%)
- ไอเทมในเกม: กรอบรูปโปรไฟล์สุดพิเศษ [Co-Creation Planner] ×1 (3%)
- ไอเทมในเกม: ฉายาสุดพิเศษ [ขว้างกิ่งไม้แห้งใส่ผู้วางแผน] ×1 (6%)
- ไอเทมในเกม: กล่องสุ่ม Kafra ×1 (10%)
- ไอเทมในเกม: Zeny ผูกกับบัญชี ×3,000 (12%)
- ไอเทมในเกม: เหรียญผจญภัย ×10,000 (30%)
- ของรางวัลจริง: โฟโต้การ์ดลิมิเต็ด BABYMONSTER Collab (ชุดเต็ม) ×1 (1%)
- ของรางวัลจริง: ตุ๊กตาลิมิเต็ด ×1 (3%)
- ของรางวัลจริง: การ์ดสะสม ×1 (4%)
- ของรางวัลจริง: กระเป๋าเป้ Collab ×1 (4%)
- ของรางวัลจริง: เสื่อปิกนิกผจญภัย ×1 (5%)

IV. กติกาการรับรางวัล
1. ฟังก์ชันรับรางวัลจะเปิดให้ใช้งานหลังกิจกรรมสิ้นสุด
2. กติกาการรับรางวัลเสมือน:
   1) รางวัลเสมือนที่ได้รับในกิจกรรมสามารถดูได้โดยคลิก "ดูรางวัลของฉัน"
   2) หลังกิจกรรมสิ้นสุด ผู้เล่นสามารถรับโค้ดของขวัญที่สอดคล้องกับรางวัลบนหน้านี้ และนำไปแลกในเกมได้
3. กติกาการรับรางวัลจริง:
   1) ผู้ที่ได้รับรางวัลต้องกรอกข้อมูลการจัดส่งที่ครบถ้วนและถูกต้องบนหน้ากิจกรรมภายใน 30 วันทำการหลังกิจกรรมสิ้นสุด การปฏิเสธหรือส่งข้อมูลล่าช้าถือว่าสละสิทธิ์รับรางวัล
   2) ข้อมูลการจัดส่งที่ต้องกรอก: ① ชื่อจริง ② เบอร์โทรศัพท์ที่ใช้งานได้ ③ ที่อยู่จัดส่งโดยละเอียดถึงเลขที่บ้าน ④ รหัสไปรษณีย์
   *กรุณาตรวจสอบความถูกต้องของข้อมูลอย่างรอบคอบ ทางการไม่รับผิดชอบต่อการจัดส่งล้มเหลว การสูญหาย หรือการส่งคืนรางวัล อันเนื่องมาจากข้อมูลที่ไม่ถูกต้อง ไม่ครบถ้วน หรือไม่สามารถติดต่อผู้รับได้ ข้อมูลส่วนตัวที่ให้ไว้จะใช้เพื่อการจัดส่งรางวัลและงานบริหารที่เกี่ยวข้องเท่านั้น ผู้จัดงานจะดูแลความลับตามกฎหมายที่เกี่ยวข้อง
   3) การจัดส่งรางวัลจริง: คาดว่าจะจัดส่งให้เสร็จสิ้นภายใน 30–60 วันทำการหลังกิจกรรมสิ้นสุด กรุณารอด้วยความอดทน
   4) โปรดทราบ: กิจกรรมนี้เปิดเฉพาะผู้เล่นในไทย กัมพูชา ติมอร์-เลสเต อินโดนีเซีย ลาว มาเลเซีย เมียนมาร์ ฟิลิปปินส์ และสิงคโปร์เท่านั้น ที่อยู่จัดส่งนอกเขตพื้นที่ดังกล่าวถือว่าสละสิทธิ์รับรางวัลจริง

V. ความรับผิดชอบและการสละสิทธิ์ของผู้เล่น
1. ผู้เล่นมีหน้าที่ติดตามกติกากิจกรรมและกำหนดเวลาทั้งหมด (ช่วงกิจกรรม ช่วงสะสม/แลกคะแนน กำหนดส่งที่อยู่ ช่วงรับรางวัลเสมือน ฯลฯ) หากผู้เล่นไม่เข้าร่วม แลกสิทธิ์จับฉลาก กรอกที่อยู่จัดส่ง หรือรับรางวัลเสมือนภายในกำหนดเวลาที่ทางการระบุ จะถือว่าสละสิทธิ์โดยอัตโนมัติ
2. ความสูญเสียทั้งหมดที่เกิดจากการสละสิทธิ์ดังกล่าว (รวมถึงแต่ไม่จำกัดเพียง คะแนนหมดอายุและรางวัลที่ไม่ได้รับ) เป็นความรับผิดชอบของผู้เล่นเอง ทางการไม่มีภาระผูกพันในการชดเชยหรือฟื้นฟูใดๆ

VI. ลิขสิทธิ์เนื้อหาและการใช้งาน
การส่งผลงานถือว่าคุณอนุญาตให้ทางการเกมมีสิทธิ์ใช้งานทั่วโลก ถาวร ไม่สามารถเพิกถอนได้ ปลอดค่าสิทธิ์ ทั้งในและนอกเกม รวมถึงการตลาด การโปรโมต การดัดแปลง และผลงานที่ดัดแปลงมา ทางการมีสิทธิ์แก้ไข ปรับปรุง ผลิต และผลิตซ้ำผลงานที่คุณส่ง และนำไปใช้ในเกม สินค้าเกม การส่งเสริมการตลาด และกิจกรรมที่เกี่ยวข้อง

VII. การต่อต้านการโกงและการจัดการการละเมิด
ทางการจะตรวจสอบพฤติกรรมการเข้าร่วมกิจกรรมอย่างเข้มงวด เมื่อตรวจพบการละเมิดต่อไปนี้ ทางการขอสงวนสิทธิ์ดำเนินการทันที รวมถึงแต่ไม่จำกัดเพียง การบล็อกบัญชีที่เกี่ยวข้อง การเพิกถอนสิทธิ์เข้าร่วมกิจกรรมทั้งหมด การเรียกคืนรางวัลที่แจกจ่ายแล้ว (รวมถึงไอเทมเสมือนที่ใช้ไปแล้ว) และการดำเนินการทางกฎหมาย:
1. การสร้างบัญชีสำรองจำนวนมาก (บุคคลเดียวกัน อุปกรณ์เดียวกัน IP เดียวกัน หลายบัญชี) เพื่อเข้าร่วมกิจกรรม
2. การใช้ช่องโหว่ เครื่องมือที่ไม่เป็นทางการ หรือวิธีการผิดปกติใดๆ เพื่อสะสมคะแนน
3. การใช้ซอฟต์แวร์บุคคลที่สามที่ผิดกฎหมาย โปรแกรมโกง หรือเครื่องมือช่วยเหลือเพื่อรบกวนกิจกรรม
4. พฤติกรรมการกดไลก์ตัวเอง กดไลก์ข้ามกัน ซื้อไลก์ หรือการโต้ตอบที่ผิดปกติ/ปลอมแปลงในรูปแบบใดๆ
5. การให้ข้อมูลส่วนตัวเท็จหรือการนำข้อมูลของผู้อื่นไปใช้
6. พฤติกรรมอื่นใดที่ทางการเห็นว่าละเมิดความยุติธรรมของกิจกรรมหรือเป็นอันตรายต่อสภาพแวดล้อมเกม

VIII. เหตุสุดวิสัย
ในกรณีที่มีเหตุสุดวิสัยที่ไม่อาจโทษทางการได้ (รวมถึงแต่ไม่จำกัดเพียง การเปลี่ยนแปลงนโยบายรัฐบาล ภัยธรรมชาติ โรคระบาด สงคราม) ทางการขอสงวนสิทธิ์ปรับกำหนดการกิจกรรม ได้แก่ การขยาย ย่อ หรือระงับกิจกรรม โดยแจ้งล่วงหน้าอย่างน้อย 24 ชั่วโมงบนเว็บไซต์ทางการหรือเพจแฟนคลับ ในกรณีเหตุสุดวิสัยฉุกเฉิน (รวมถึงแต่ไม่จำกัดเพียง เซิร์ฟเวอร์ล่มครั้งใหญ่ การโจมตีแฮกเกอร์) ที่ไม่สามารถแจ้งล่วงหน้าได้ ทางการสัญญาจะแจ้งให้เร็วที่สุดเท่าที่ทำได้

IX. ข้อยกเว้นความรับผิดชอบ
การเข้าร่วมกิจกรรมนี้ถือว่าคุณได้อ่าน เข้าใจ และยอมรับสิ่งต่อไปนี้อย่างครบถ้วน:
1. หากคุณเป็นผู้เยาว์หรือบุคคลที่มีความสามารถจำกัด คุณได้รับความยินยอมจากผู้ปกครองตามกฎหมายก่อนเข้าร่วม
2. การสละสิทธิ์ตามกำหนดเวลา: การไม่ดำเนินการที่จำเป็นให้เสร็จสิ้นภายในกรอบเวลาที่ทางการกำหนด (ช่วงแลกคะแนน กำหนดส่งที่อยู่ ช่วงรับรางวัลเสมือน ฯลฯ) จะถือว่าสละสิทธิ์โดยอัตโนมัติ
3. ความรับผิดชอบต่อข้อผิดพลาดของข้อมูล: ทางการไม่รับผิดชอบต่อความไม่สามารถสะสมคะแนน เข้าร่วมจับฉลาก รับรางวัล หรือความสูญเสียใดๆ อันเนื่องมาจากข้อมูลส่วนตัวที่ไม่ถูกต้อง เท็จ หมดอายุ หรือไม่ได้อัปเดตทันเวลา (รวมถึงแต่ไม่จำกัดเพียง ข้อมูลการจัดส่งและข้อมูลบัญชี) ที่ผู้เล่นให้ไว้
4. ความรับผิดชอบต่อความปลอดภัยและสถานะของบัญชี: ทางการไม่รับผิดชอบต่อความไม่สามารถเข้าร่วมกิจกรรม การสูญเสียคะแนน รางวัลที่ไม่ได้รับ หรือความสูญเสียใดๆ อันเนื่องมาจากบัญชีถูกแฮก ปัญหาอุปกรณ์ส่วนตัว ปัญหาเครือข่าย หรือบัญชีถูกระงับเนื่องจากละเมิดกฎเกม หากบัญชีถูกระงับในช่วงกิจกรรม คะแนนที่ยังไม่ได้ใช้และรางวัลที่ยังไม่ได้แจกจ่ายจะถือว่าเป็นโมฆะโดยอัตโนมัติ
5. บันทึกระบบเป็นหลักฐานสำคัญ: บันทึกการสะสมคะแนน การใช้คะแนน การจับฉลาก และการรับรางวัลทั้งหมด จะยึดตามข้อมูลในระบบหลังบ้านทางการเป็นหลักฐานขั้นสุดท้าย

※ 《Ragnarok: The New World》 ขอสงวนสิทธิ์ในการตีความกิจกรรมนี้ขั้นสุดท้าย และอาจปรับหรือเพิ่มเติมเนื้อหากิจกรรม กติกา และรางวัลตามสถานการณ์จริงภายในขอบเขตที่กฎหมายอนุญาต ประกาศทางการถือเป็นหลักฐานที่ใช้ยึดถือ`,
  rulePopupContent: ``,
  createPopupTip: "ด้วยการส่ง คุณให้สิทธิ์ใช้งานทั่วโลก ถาวร ไม่สามารถเพิกถอนได้ ปลอดค่าสิทธิ์แก่ทางการเกมอย่างเป็นทางการ สำหรับการใช้งานทั้งในและนอกเกม รวมถึงการตลาด การโปรโมต การดัดแปลง และผลงานที่ดัดแปลงมา",
  checkTermsTip: 'กรุณายอมรับข้อกำหนดการอนุญาต',
  imageUploadingTip: 'กำลังอัปโหลดรูปภาพ กรุณารอสักครู่',
  imageSizeTip: 'ขนาดรูปภาพต้องไม่เกิน 10MB',
  imageFormatTip: 'รองรับเฉพาะรูปแบบ JPG และ PNG',
  imageMaxTip: 'อัปโหลดได้สูงสุด 3 รูป',
  imageUploadFailTip: 'อัปโหลดรูปภาพล้มเหลว กรุณาลองใหม่',
  saveConfirmMessage: 'คุณต้องการเก็บการแก้ไขครั้งนี้ไว้หรือไม่?',
  footerRatingLines: ['เกมนี้มีเนื้อหาเกี่ยวกับความรุนแรงและความรักใคร่', 'เนื้อหาบางส่วนต้องชำระเงินเพิ่มเติม', 'โปรดหลีกเลี่ยงการเล่นเกมมากเกินไป'],
  footerTermsText: 'ข้อกำหนดการให้บริการ',
  footerPrivacyText: 'นโยบายความเป็นส่วนตัว',
  awardThanks: 'ขอบคุณที่เข้าร่วม',
  awardTitle: 'ฉายาสั่งทำพิเศษ [ปา Dead Branch ใส่ทีมงาน]*1',
  awardAvatar: 'กรอบอวาตาร์สั่งทำพิเศษ [นักวางแผนร่วมสร้างสรรค์]*1',
  awardHeadwear: 'Headwear สั่งทำพิเศษ [Black Cat Ears]*1',
  awardBlindbox: 'Kafra Blind Box*1',
  awardZeny: 'Zeny ผูกมัด*3000',
  awardCoin: 'Adventure Coin*10000',
  awardDoll: 'ตุ๊กตาจำกัด',
  awardCard: 'การ์ดสะสม',
  awardTshirt: 'เสื้อยืด ROW',
  awardBackpack: 'กระเป๋าเป้คอลแลบ',
  awardPhotocard: 'โฟโต้การ์ดลิมิเต็ดคอลแลบ BABYMONSTER ครบเซ็ต',
  awardPhoneHolder: 'ที่วางโทรศัพท์ Baphomet',
  awardCanvasBag: 'กระเป๋าผ้า New World',
  awardFridgeMagnet: 'แม่เหล็กตู้เย็น Novice',
  awardWaistPillow: 'หมอนหนุนหลัง RO',
  scoreTitleNone: 'ไม่มี',
  scoreTitleLv1: 'Novice ไอเดียบันเจิดสุดๆ',
  scoreTitleLv2: 'โลกกว้าง RO เล่นยังไงก็คุ้ม',
  scoreTitleLv3: 'ไม่ปิดบังแล้ว ข้าคือเทพผู้สร้าง',
  footerTermsUrl: 'https://www.gnjoy.hk/Terms',
  footerPrivacyUrl: 'https://www.gnjoy.hk/Policies',
};
